import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'wsb-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.scss'],
  standalone: false
})
export class SlideToggleComponent {
  @Input() toggleControl: UntypedFormControl;
  @Input() leftText: string;
  @Input() rightText: string;
}
